// extracted by mini-css-extract-plugin
export var blue = "_44-f";
export var brand = "_44-b";
export var darkGrey = "_44-e";
export var disabled = "_44-4";
export var disabledSubtle = "_44-5";
export var error = "_44-6";
export var green = "_44-g";
export var grey = "_44-d";
export var icon = "_44-0";
export var inherit = "_44-a";
export var lightGrey = "_44-c";
export var orange = "_44-i";
export var pink = "_44-k";
export var primary = "_44-1";
export var purple = "_44-l";
export var red = "_44-j";
export var secondary = "_44-2";
export var success = "_44-9";
export var tertiary = "_44-3";
export var warning = "_44-7";
export var warningSecondary = "_44-8";
export var white = "_44-m";
export var yellow = "_44-h";